//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Formboard.js";
import "../no/Builder.js";
import "../Formboard/Formboard.LayoutLengthOptions.js";
let d=[[[1,"LengthOptions",0,"Formboard.LayoutLengthOptions",0]],[[[],"GetHarnessPart",{R_:{harnessPart:"Part"}},0,0],[["harnessPart"],"SetHarnessPart",{},1,0],[["harnesses"],"SetHarnesses",{},1,0],[[],"FindMapping",{},0,0],[[],"DetermineDiscrepancies",{},0,0],[[],"GetNumberOfDiscrepancies",{R_:{numDiscreps:''}},0,0],[["index"],"GetDiscrepancy",{R_:{discrep:"Formboard.UpdateDiscrepancy"}},1,0],[[],"RemoveBendsOfRadialBends",{},0,0],[[],"CreateBendsOfRadialBends",{},0,0]],[]];
SPLM.Formboard.UpdateFormboardBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Formboard.UpdateFormboardBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;